import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import {LoadingStates} from '@Utils/loading.util';
import {
  closeAiActionLoadingModal,
  isCurrentModalSession,
  openVideoEditorLoadingModalAndGetSessionId,
  showVideoEditorReadyModal,
} from '@Components/ai-chat-window/lib/ai-action-loading-modal.library';
import {getPosterHashedIdForAiChatAnimationAsset} from '@Components/ai-chat-window/lib/chat-attachment-image.library';
import {GA4EventName} from '@Libraries/ga-events';

interface UseOpenChatAnimationInEditorProps {
  chatId: string;
  animationHashedId: string;
}

interface UseOpenChatAnimationInEditor {
  openAnimationInEditor: () => Promise<void>;
  isLoading: boolean;
}

export const useOpenChatAnimationInEditor = ({chatId, animationHashedId}: UseOpenChatAnimationInEditorProps): UseOpenChatAnimationInEditor => {
  const {state, actions} = useAiChat();

  const isLoading = state.getLoadingStatesForAnimationActions(chatId, animationHashedId).openEditorLoadingState === LoadingStates.LOADING;

  const openAnimationInEditor = async (): Promise<void> => {
    actions.updateLoadingStatesForAnimationActions(chatId, animationHashedId, {
      openEditorLoadingState: LoadingStates.LOADING,
    });
    const sessionId = openVideoEditorLoadingModalAndGetSessionId();

    try {
      const fetchedPosterHashedId = await getPosterHashedIdForAiChatAnimationAsset(animationHashedId);
      window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_TURNTOVIDEO_OPENINEDITOR);
      actions.updateLoadingStatesForAnimationActions(chatId, animationHashedId, {
        openEditorLoadingState: LoadingStates.LOADED,
      });

      if (!isCurrentModalSession(sessionId)) {
        return;
      }

      showVideoEditorReadyModal(window.PMW.util.site_url(`posterbuilder/load/${fetchedPosterHashedId}`));
    } catch (e: unknown) {
      actions.updateLoadingStatesForAnimationActions(chatId, animationHashedId, {
        openEditorLoadingState: LoadingStates.NOT_LOADED,
      });
      closeAiActionLoadingModal();
      console.error(e);
    }
  };

  return {openAnimationInEditor, isLoading};
};
